export default __webpack_public_path__ + "static/media/chatprofile.abfd52f1d5399aa21a84d7aad1589589.svg";